exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-link {\n  text-decoration:none;\n}\n\na.disabled {\n  pointer-events: none;\n  cursor: default;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/navbar/left-nav/left-nav.component.css
// module id = ../../../../../src/app/navbar/left-nav/left-nav.component.css
// module chunks = main